import React from 'react';
import HeroHeader from './HeroHeader';
import CalculadoraConsumo from './CalculadoraConsumo';
// import IconBlocks from './IconBlocks';
import AboutInfo from './AboutInfo';
// import NewsBlock from './NewsBlock';
// import ProductsBlock from './ProductsBlock';
// import ContactView from '../Contacto';

const HomeView = props => (
  <div>
    <HeroHeader />
    <AboutInfo />
    <CalculadoraConsumo {...props} />
    {/* <ContactView /> */}
  </div>
);

export default HomeView;



// WEBPACK FOOTER //
// ./src/components/Home/index.js